interface IDepartureIconProps {
  mainColor?: string;
  secondaryColor?: string;
  className?: string | undefined;
}

const DepartureIcon: React.FC<IDepartureIconProps> = ({
  mainColor,
  secondaryColor,
  className,
}) => (
  <svg
    width="61"
    height="61"
    viewBox="0 0 61 61"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g fill="none" fillRule="evenodd">
      <path
        style={{ fill: mainColor || 'var(--tt-dark-purple)' }}
        d="m52.93 7.873 2.51 2.51-35.14 35.14-17.532-.002-.038-5.018 15.06-2.51 10.04-10.04-12.55-15.06 2.51-2.51 17.57 10.04 10.04-10.04z"
      />
      <path
        style={{ fill: secondaryColor || 'var(--tt-yellow)' }}
        d="M57.95 53.146H2.73v-2.51h55.22z"
      />
    </g>
  </svg>
);

export default DepartureIcon;
